export default "__VITE_ASSET__3698fa6c__"